import './ccf-max-icon.module.scss';

import { SvgIcon,SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfMaxIconProps extends SvgIconProps {}
/**
 * Component used to display  align center Icon
 * @param props - CcfAcdIconProps
 * @example - <CcfAcdIcon />
 * @returns SVG of align center Icon
 */
export function CcfMaxIcon(props: CcfMaxIconProps) {
  return (
    <SvgIcon {...props}>
       <path fill="#ff8000" d="M14.5 1c0 0 0 0 0 0-7.4 0-13.4 6-13.4 13.4 0 1.3 0.2 2.6 0.5 3.8v-0.1l1 3.6c0.2 0.7 0.8 1.2 1.5 1.2 0.2 0 0.3 0 0.4-0.1v0c0 0-1.4-5-1.4-5.2-0.3-1-0.5-2.1-0.5-3.2 0.1-6.5 5.4-11.8 11.9-11.8s11.8 5.3 11.8 11.8c0 1.2-0.2 2.3-0.5 3.3v-0.1c0 0.2-1.4 5.2-1.4 5.2 0.1 0 0.3 0.1 0.4 0.1 0.7 0 1.4-0.5 1.5-1.2v0l1-3.6c0.3-1.1 0.5-2.4 0.5-3.7 0.1-7.4-5.9-13.4-13.3-13.4 0 0 0 0 0 0v0 0z"/>
    <path fill="#b3b3b3" d="M19.1 29.7h-1.3c-0.2 0-0.4-0.2-0.4-0.4v0 0c0-0.2 0.2-0.4 0.4-0.4v0h1.3c1.3 0 2.3-1 2.3-2.3v-2.1h0.8v2.1c0 1.7-1.4 3.1-3.1 3.1v0 0z"/>
    <path fill="#ff8000" d="M16.9 29.3c0 0.9-1.3 1.7-2.8 1.7s-2-0.8-2-1.7c0-0.9 0.5-1.7 2-1.7s2.8 0.8 2.8 1.7z"/>
    <path fill="#ff8000" d="M8.1 25.4l-0.3 0.1c-0.1 0-0.2 0-0.3 0 0 0 0 0-0.1 0v0h-0.7c-0.5 0-0.9-0.3-1-0.8v0l-1.6-5.7c0-0.1 0-0.2 0-0.3 0-0.4 0.2-0.7 0.5-0.9v0l0.6-0.4c0.1-0.1 0.2-0.1 0.3-0.1v0l0.3-0.1c0 0 0.1 0 0.1 0 0.2 0 0.4 0.2 0.5 0.4v0l2 7.2c0 0 0 0.1 0 0.1 0.1 0.2 0 0.4-0.3 0.5 0 0 0 0 0 0z"/>
    <path fill="#b3b3b3" d="M7.4 16.7l0.9-0.3c0.3-0.1 0.7 0.1 0.7 0.4l2 7.1c0.1 0.3-0.1 0.7-0.4 0.7l-0.9 0.3c-0.3 0.1-0.6-0.1-0.7-0.4l-2-7.1c-0.1-0.3 0.1-0.6 0.4-0.7z"/>
    <path fill="#ff8000" d="M20.9 25.4l0.3 0.1c0.1 0 0.2 0 0.3 0 0 0 0 0 0.1 0v0h0.7c0.5 0 0.9-0.3 1-0.8v0l1.6-5.7c0-0.1 0-0.2 0-0.3 0-0.4-0.2-0.7-0.5-0.9v0l-0.6-0.4c-0.1-0.1-0.2-0.1-0.3-0.1v0l-0.3-0.1c0 0-0.1 0-0.1 0-0.2 0-0.5 0.2-0.5 0.4v0l-2 7.2c0 0 0 0.1 0 0.1-0.1 0.2 0 0.4 0.3 0.5 0 0 0 0 0 0z"/>
    <path fill="#b3b3b3" d="M19.3 24.9l-0.9-0.3c-0.3-0.1-0.5-0.4-0.4-0.7l2-7.1c0.1-0.3 0.4-0.5 0.7-0.4l0.9 0.3c0.3 0.1 0.5 0.4 0.4 0.7l-2 7.1c-0.1 0.3-0.4 0.5-0.7 0.4z"/>
    <path fill="#b3b3b3" d="M14.5 3.1c-5.2 0-9.6 3.6-10.9 8.4v0.1c0.1 0 0.2 0 0.3 0 0.5 0 0.9-0.3 1.1-0.8v0c1.5-3.9 5.2-6.7 9.6-6.7s8 2.9 9.4 6.7v0.1c0.2 0.4 0.6 0.8 1.1 0.8 0.1 0 0.2 0 0.3 0v0c-1.3-5-5.7-8.6-10.9-8.6v0 0z"/>
    </SvgIcon>
  );
}

export default CcfMaxIcon;
